const createPlatformImageUrl = () => void 0;
export {
  createPlatformImageUrl
};
//# sourceMappingURL=image.js.map
